import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "main-content",
  class: "ml-64 p-8"
}
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { class: "flex items-center space-x-3 mb-2" }
const _hoisted_4 = { class: "text-2xl font-bold text-green-800" }
const _hoisted_5 = {
  key: 0,
  class: "bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8"
}
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6" }
const _hoisted_7 = { class: "flex items-center space-x-2" }
const _hoisted_8 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_9 = { class: "flex items-center space-x-2" }
const _hoisted_10 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_11 = { class: "flex items-center space-x-2" }
const _hoisted_12 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_13 = { class: "flex items-center space-x-2" }
const _hoisted_14 = { class: "text-sm text-gray-900" }
const _hoisted_15 = { class: "flex items-center space-x-2" }
const _hoisted_16 = { class: "text-sm text-gray-900" }
const _hoisted_17 = { class: "flex items-center space-x-2" }
const _hoisted_18 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_19 = {
  key: 1,
  class: "text-sm font-semibold text-gray-900"
}
const _hoisted_20 = { class: "bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8" }
const _hoisted_21 = { class: "flex items-center justify-between mb-4" }
const _hoisted_22 = {
  key: 0,
  class: "text-xs text-gray-400"
}
const _hoisted_23 = {
  key: 0,
  class: "text-sm text-gray-400 text-center py-4"
}
const _hoisted_24 = {
  key: 1,
  class: "flex flex-wrap gap-2"
}
const _hoisted_25 = {
  key: 0,
  class: "text-green-600 font-normal"
}
const _hoisted_26 = { class: "mb-6 flex items-center justify-between" }
const _hoisted_27 = { class: "bg-white rounded-lg shadow-sm border border-gray-200" }
const _hoisted_28 = {
  key: 0,
  class: "flex justify-center items-center h-48"
}
const _hoisted_29 = {
  key: 1,
  class: "p-8 text-center text-gray-500"
}
const _hoisted_30 = {
  key: 2,
  class: "overflow-x-auto"
}
const _hoisted_31 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_32 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_33 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_34 = { class: "flex items-center" }
const _hoisted_35 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_36 = { class: "text-sm text-gray-500" }
const _hoisted_37 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_38 = {
  key: 0,
  class: "px-2 py-1 text-xs font-medium bg-red-100 text-red-800 rounded-full"
}
const _hoisted_39 = {
  key: 1,
  class: "px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full"
}
const _hoisted_40 = {
  key: 2,
  class: "px-2 py-1 text-xs font-medium bg-indigo-100 text-indigo-800 rounded-full"
}
const _hoisted_41 = {
  key: 3,
  class: "px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-800 rounded-full"
}
const _hoisted_42 = {
  key: 4,
  class: "px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded-full"
}
const _hoisted_43 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_44 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium" }
const _hoisted_45 = { class: "flex items-center space-x-3" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 3,
  class: "px-6 py-4 border-t border-gray-200"
}
const _hoisted_49 = { class: "flex items-center justify-between" }
const _hoisted_50 = { class: "text-sm text-gray-700" }
const _hoisted_51 = { class: "font-medium" }
const _hoisted_52 = { class: "font-medium" }
const _hoisted_53 = { class: "flex items-center space-x-2" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 0,
  class: "flex justify-center items-center h-32"
}
const _hoisted_57 = { class: "space-y-1" }
const _hoisted_58 = { class: "space-y-1" }
const _hoisted_59 = { class: "space-y-1" }
const _hoisted_60 = { class: "flex justify-end space-x-2 pt-2" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = {
  key: 0,
  class: "flex justify-center items-center h-32"
}
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "flex items-center space-x-3 pb-4 mb-4 border-b border-gray-100" }
const _hoisted_65 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_66 = { class: "text-xs text-gray-500" }
const _hoisted_67 = {
  key: 0,
  class: "flex justify-center items-center h-24"
}
const _hoisted_68 = {
  key: 1,
  class: "py-6 text-center text-sm text-gray-400"
}
const _hoisted_69 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_70 = { class: "flex items-center space-x-2 min-w-0" }
const _hoisted_71 = { class: "text-sm text-gray-800 font-mono truncate" }
const _hoisted_72 = {
  key: 0,
  class: "ml-1 px-1.5 py-0.5 text-xs font-medium bg-indigo-100 text-indigo-700 rounded flex-shrink-0"
}
const _hoisted_73 = {
  key: 0,
  disabled: "",
  class: "ml-3 flex-shrink-0 w-7 h-7 flex items-center justify-center"
}
const _hoisted_74 = ["onClick"]
const _hoisted_75 = ["onClick"]

import { onMounted, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useOrganizationStore } from '@/store/organizations';
import { useUserStore } from '@/store/users';
import { useNotificationStore } from '@/store/notifications';
import { useBillingStore } from '@/store/billing';
import { usePermissionStore } from '@/store/permissions';
import { useServicesStore } from '@/store/services';
import type { Organization, User } from '@/config/types/responses';
import Header from '../components/header.vue';
import SideBar from '../components/sidebar.vue';
import Modal from '../components/modal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'organization_detail',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const organizationStore = useOrganizationStore();
const userStore = useUserStore();
const notificationStore = useNotificationStore();
const billingStore = useBillingStore();
const permissionStore = usePermissionStore();
const servicesStore = useServicesStore();

const organization = ref<Organization | null>(null);
const showRegisterModal = ref(false);
const registerLoading = ref(false);
const currentPage = ref(1);

const showPermissionsModal = ref(false);
const permissionsUser = ref<User | null>(null);
const actioningPermissionId = ref<string | null>(null);

const registerForm = ref({
  firstName: '',
  lastName: '',
  emailAddress: '',
});

const organizationId = computed(() => route.params.id as string);
onMounted(async () => {
  await organizationStore.fetchOrganizations(1);
  organization.value = organizationStore.organizationResults.find(
    (o) => o.id === organizationId.value,
  ) ?? null;

  userStore.fetchUsersByOrganization(organizationId.value, currentPage.value);
  billingStore.fetchOrganizationBalance(organizationId.value);
  servicesStore.fetchOrgSubscriptions(organizationId.value);
  permissionStore.fetchPermissions();
});

function formatDate(input: string) {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  }).format(new Date(input));
}

function changePage(page: number) {
  currentPage.value = page;
  userStore.fetchUsersByOrganization(organizationId.value, page);
}

function closeRegisterModal() {
  showRegisterModal.value = false;
  registerForm.value = { firstName: '', lastName: '', emailAddress: '' };
  userStore.error = null;
}

async function openPermissionsModal(user: User) {
  permissionsUser.value = user;
  showPermissionsModal.value = true;
  await permissionStore.fetchUserPermissions(user.id);
}

function closePermissionsModal() {
  showPermissionsModal.value = false;
  permissionsUser.value = null;
  permissionStore.userPermissions = [];
  actioningPermissionId.value = null;
}

function isAssigned(permissionId: string): boolean {
  return permissionStore.userPermissions.some((p) => p.id === permissionId);
}

async function handleAssignPermission(permissionId: string) {
  if (!permissionsUser.value) return;
  actioningPermissionId.value = permissionId;
  await permissionStore.assignPermission(permissionsUser.value.id, permissionId);
  if (permissionStore.error) {
    notificationStore.showError('Assignment Failed', permissionStore.error);
  }
  actioningPermissionId.value = null;
}

async function handleRemovePermission(permissionId: string) {
  if (!permissionsUser.value) return;
  actioningPermissionId.value = permissionId;
  await permissionStore.removePermission(permissionsUser.value.id, permissionId);
  if (permissionStore.error) {
    notificationStore.showError('Removal Failed', permissionStore.error);
  }
  actioningPermissionId.value = null;
}

async function handleResetPassword(userId: string) {
  try {
    await userStore.resetPassword(userId);
    if (userStore.error) {
      notificationStore.showError('Reset Failed', userStore.error);
    } else {
      notificationStore.showSuccess('Password Reset', 'A new password has been sent to the user\'s email.');
    }
  } catch (err) {
    notificationStore.showError('Reset Error', 'An unexpected error occurred.');
  }
}

async function handleRegisterUser() {
  if (!registerForm.value.firstName || !registerForm.value.lastName || !registerForm.value.emailAddress) {
    notificationStore.showError('Validation Error', 'Please fill in all required fields.');
    return;
  }

  registerLoading.value = true;
  try {
    await userStore.registerUser(
      registerForm.value.firstName,
      registerForm.value.lastName,
      registerForm.value.emailAddress,
      organizationId.value,
    );

    if (userStore.error) {
      notificationStore.showError('Registration Failed', userStore.error);
    } else {
      notificationStore.showSuccess('User Registered', 'The user has been registered successfully.');
      closeRegisterModal();
      userStore.fetchUsersByOrganization(organizationId.value, currentPage.value);
    }
  } catch (err) {
    notificationStore.showError('Registration Error', 'An unexpected error occurred.');
  } finally {
    registerLoading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(SideBar),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back())),
            class: "text-gray-500 hover:text-gray-700"
          }, _cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "fa-solid fa-arrow-left" }, null, -1)
          ])),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(organization.value?.name || 'Organization'), 1),
          (organization.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass({
          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full': true,
          'bg-green-100 text-green-800': organization.value.status === 'Active',
          'bg-yellow-100 text-yellow-800': organization.value.status === 'Inactive',
          'bg-red-100 text-red-800': organization.value.status === 'Disabled',
        })
              }, _toDisplayString(organization.value.status), 3))
            : _createCommentVNode("", true)
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-gray-600 text-sm ml-7" }, "Organization profile and user management", -1))
      ]),
      (organization.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4" }, "Profile", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-xs text-gray-500 uppercase tracking-wider mb-1" }, "Organization Name", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa-solid fa-building text-green-600" }, null, -1)),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(organization.value.name), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-xs text-gray-500 uppercase tracking-wider mb-1" }, "Contact Person", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa-solid fa-user text-green-600" }, null, -1)),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(organization.value.contactName), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-xs text-gray-500 uppercase tracking-wider mb-1" }, "Contact Email", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa-solid fa-envelope text-green-600" }, null, -1)),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(organization.value.contactEmail), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-xs text-gray-500 uppercase tracking-wider mb-1" }, "Created", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa-solid fa-calendar text-green-600" }, null, -1)),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(formatDate(organization.value.createdAt)), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-xs text-gray-500 uppercase tracking-wider mb-1" }, "Last Updated", -1)),
                _createElementVNode("div", _hoisted_15, [
                  _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fa-solid fa-clock text-green-600" }, null, -1)),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(formatDate(organization.value.updatedAt)), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-xs text-gray-500 uppercase tracking-wider mb-1" }, "Account Balance", -1)),
                _createElementVNode("div", _hoisted_17, [
                  _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fa-solid fa-wallet text-green-600" }, null, -1)),
                  (_unref(billingStore).balanceLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Loading..."))
                    : (_openBlock(), _createElementBlock("span", _hoisted_19, " UGX " + _toDisplayString(_unref(billingStore).balance !== null ? Number(_unref(billingStore).balance).toLocaleString('en-US', {
                minimumFractionDigits: 2, maximumFractionDigits: 2
              }) : '—'), 1))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-500 uppercase tracking-wider" }, "Subscribed Services", -1)),
          (_unref(servicesStore).loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Loading..."))
            : _createCommentVNode("", true)
        ]),
        (!_unref(servicesStore).loading && !_unref(servicesStore).subscriptions?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, " No services subscribed "))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(servicesStore).subscriptions, (sub) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: sub.id,
                  class: "inline-flex items-center space-x-1.5 px-3 py-1.5 bg-green-50 border border-green-200 text-green-800 text-xs font-medium rounded-full"
                }, [
                  _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fa-solid fa-cube text-green-600" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(sub.serviceName), 1),
                  (sub.rate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "· " + _toDisplayString(sub.rate), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
      ]),
      _createElementVNode("div", _hoisted_26, [
        _cache[25] || (_cache[25] = _createElementVNode("div", null, [
          _createElementVNode("h3", { class: "text-lg font-semibold text-gray-800" }, "Users"),
          _createElementVNode("p", { class: "text-sm text-gray-500" }, "Users registered under this organization")
        ], -1)),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showRegisterModal.value = true)),
          class: "bg-green-800 hover:bg-green-700 text-white px-5 py-2.5 rounded-md flex items-center space-x-2 font-medium bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg focus:ring-green-500 transition-all duration-200 transform hover:scale-[1.02]"
        }, _cache[24] || (_cache[24] = [
          _createElementVNode("i", { class: "fa-solid fa-user-plus mr-1" }, null, -1),
          _createElementVNode("span", null, "Register User", -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_27, [
        (_unref(userStore).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[26] || (_cache[26] = [
              _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
            ])))
          : (!_unref(userStore).users?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, " No users found for this organization "))
            : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("table", _hoisted_31, [
                  _cache[30] || (_cache[30] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "User"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Status"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Created"),
                      _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Actions")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore).users, (user) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: user.id
                      }, [
                        _createElementVNode("td", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "h-9 w-9 rounded-full bg-green-800 flex items-center justify-center mr-3 flex-shrink-0" }, [
                              _createElementVNode("i", { class: "fa-solid fa-user text-white text-sm" })
                            ], -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_35, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1),
                              _createElementVNode("div", _hoisted_36, _toDisplayString(user.emailAddress?.String), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_37, [
                          (user.status === 'NOT_VERIFIED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Not Verified"))
                            : (user.status === 'VERIFIED')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Verified"))
                              : (user.status === 'ACTIVE')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Active"))
                                : (user.status === 'INACTIVE')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Inactive"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(user.status), 1))
                        ]),
                        _createElementVNode("td", _hoisted_43, _toDisplayString(formatDate(user.createdAt)), 1),
                        _createElementVNode("td", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (handleResetPassword(user.id)),
                              title: "Reset Password",
                              class: "text-amber-600 hover:text-amber-800"
                            }, _cache[28] || (_cache[28] = [
                              _createElementVNode("i", { class: "fa-solid fa-key" }, null, -1)
                            ]), 8, _hoisted_46),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (openPermissionsModal(user)),
                              title: "Manage Permissions",
                              class: "text-indigo-600 hover:text-indigo-800"
                            }, _cache[29] || (_cache[29] = [
                              _createElementVNode("i", { class: "fa-solid fa-shield-halved" }, null, -1)
                            ]), 8, _hoisted_47)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])),
        (_unref(userStore).pagination.totalPages && _unref(userStore).pagination.totalPages > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _cache[31] || (_cache[31] = _createTextVNode(" Page ", -1)),
                  _createElementVNode("span", _hoisted_51, _toDisplayString(_unref(userStore).pagination.currentPage), 1),
                  _cache[32] || (_cache[32] = _createTextVNode(" of ", -1)),
                  _createElementVNode("span", _hoisted_52, _toDisplayString(_unref(userStore).pagination.totalPages), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("button", {
                    disabled: currentPage.value <= 1,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (changePage(currentPage.value - 1))),
                    class: "px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                  }, " Previous ", 8, _hoisted_54),
                  _createElementVNode("button", {
                    disabled: !_unref(userStore).pagination.nextPage,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (changePage(currentPage.value + 1))),
                    class: "px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                  }, " Next ", 8, _hoisted_55)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(Modal, {
        show: showRegisterModal.value,
        title: "Register User",
        size: "max-w-lg",
        onClose: closeRegisterModal
      }, {
        default: _withCtx(() => [
          (registerLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, _cache[33] || (_cache[33] = [
                _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("form", {
                key: 1,
                class: "space-y-5",
                onSubmit: _withModifiers(handleRegisterUser, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_57, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "First Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((registerForm.value.firstName) = $event)),
                    type: "text",
                    required: "",
                    class: "block w-full pl-4 pr-3 py-3 border border-gray-300 rounded-sm text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                    placeholder: "John"
                  }, null, 512), [
                    [_vModelText, registerForm.value.firstName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Last Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((registerForm.value.lastName) = $event)),
                    type: "text",
                    required: "",
                    class: "block w-full pl-4 pr-3 py-3 border border-gray-300 rounded-sm text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                    placeholder: "Doe"
                  }, null, 512), [
                    [_vModelText, registerForm.value.lastName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Email Address", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((registerForm.value.emailAddress) = $event)),
                    type: "email",
                    required: "",
                    class: "block w-full pl-4 pr-3 py-3 border border-gray-300 rounded-sm text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                    placeholder: "john@example.com"
                  }, null, 512), [
                    [_vModelText, registerForm.value.emailAddress]
                  ]),
                  _cache[37] || (_cache[37] = _createElementVNode("p", { class: "text-gray-500 text-xs" }, "This will be the user's login username", -1))
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: closeRegisterModal,
                    class: "px-4 py-2 bg-gray-200 text-gray-700 rounded-sm hover:bg-gray-300 text-sm"
                  }, " Cancel "),
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: _unref(userStore).loading,
                    class: "bg-green-800 hover:bg-green-700 text-white px-6 py-2 rounded-md flex items-center space-x-2 font-medium bg-gradient-to-r from-green-700 to-green-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-200 disabled:opacity-50 text-sm"
                  }, _cache[38] || (_cache[38] = [
                    _createElementVNode("i", { class: "fa-solid fa-user-plus mr-2" }, null, -1),
                    _createTextVNode(" Register User ", -1)
                  ]), 8, _hoisted_61)
                ])
              ], 32))
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(Modal, {
        show: showPermissionsModal.value,
        title: "Manage Permissions",
        size: "max-w-lg",
        onClose: closePermissionsModal
      }, {
        default: _withCtx(() => [
          (_unref(permissionStore).loading && !permissionsUser.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, _cache[39] || (_cache[39] = [
                _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
              ])))
            : (permissionsUser.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "h-10 w-10 rounded-full bg-indigo-700 flex items-center justify-center flex-shrink-0" }, [
                      _createElementVNode("i", { class: "fa-solid fa-user text-white text-sm" })
                    ], -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_65, _toDisplayString(permissionsUser.value.firstName) + " " + _toDisplayString(permissionsUser.value.lastName), 1),
                      _createElementVNode("p", _hoisted_66, _toDisplayString(permissionsUser.value.emailAddress?.String), 1)
                    ])
                  ]),
                  (_unref(permissionStore).loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, _cache[41] || (_cache[41] = [
                        _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
                      ])))
                    : (!_unref(permissionStore).permissions.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, " No permissions available "))
                      : (_openBlock(), _createElementBlock("ul", _hoisted_69, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(permissionStore).permissions, (perm) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: perm.id,
                              class: _normalizeClass(["flex items-center justify-between px-3 py-2.5 rounded-md border", isAssigned(perm.id) ? 'border-indigo-200 bg-indigo-50' : 'border-gray-200 bg-white'])
                            }, [
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["fa-solid fa-shield-halved text-sm flex-shrink-0", isAssigned(perm.id) ? 'text-indigo-600' : 'text-gray-400'])
                                }, null, 2),
                                _createElementVNode("span", _hoisted_71, _toDisplayString(perm.permission), 1),
                                (isAssigned(perm.id))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_72, " Assigned "))
                                  : _createCommentVNode("", true)
                              ]),
                              (actioningPermissionId.value === perm.id)
                                ? (_openBlock(), _createElementBlock("button", _hoisted_73, _cache[42] || (_cache[42] = [
                                    _createElementVNode("div", { class: "animate-spin rounded-full h-4 w-4 border-b-2 border-green-600" }, null, -1)
                                  ])))
                                : (isAssigned(perm.id))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      onClick: ($event: any) => (handleRemovePermission(perm.id)),
                                      title: "Remove permission",
                                      class: "ml-3 flex-shrink-0 px-2.5 py-1 text-xs font-medium text-red-600 border border-red-200 rounded hover:bg-red-50 transition-colors"
                                    }, " Remove ", 8, _hoisted_74))
                                  : (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      onClick: ($event: any) => (handleAssignPermission(perm.id)),
                                      title: "Assign permission",
                                      class: "ml-3 flex-shrink-0 px-2.5 py-1 text-xs font-medium text-indigo-600 border border-indigo-200 rounded hover:bg-indigo-50 transition-colors"
                                    }, " Assign ", 8, _hoisted_75))
                            ], 2))
                          }), 128))
                        ])),
                  _createElementVNode("div", { class: "flex justify-end pt-4 mt-2 border-t border-gray-100" }, [
                    _createElementVNode("button", {
                      onClick: closePermissionsModal,
                      class: "px-4 py-2 bg-gray-100 text-gray-700 rounded-sm hover:bg-gray-200 text-sm"
                    }, " Done ")
                  ])
                ]))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}
}

})